import { IS_WHATS_NEW_MODAL_SHOW_QUERY_OPTIONS, hideWhatsNewModal } from '@/utils/whatsNew'
import { css } from '@emotion/react'
import { Modal } from '@mantine/core'
import { IconSparkles } from '@tabler/icons-react'
import { useQuery } from '@tanstack/react-query'
import type { HTMLAttributes } from 'react'
import ChangeLog from './ChangeLog'

export interface WhatsNewModalProps extends HTMLAttributes<HTMLDivElement> {}

export default function WhatsNewModal({ ...props }: WhatsNewModalProps) {
	const { data: isShow } = useQuery(IS_WHATS_NEW_MODAL_SHOW_QUERY_OPTIONS)
	return (
		<Modal
			css={css`
				--max-width: 800px;

				max-width: var(--max-width);
			`}
			opened={!!isShow}
			onClose={() => hideWhatsNewModal()}
			title={
				<div
					css={css`
						--gap: 4px;

						display: flex;
						align-items: center;
						justify-content: center;
						gap: var(--gap);
					`}
				>
					<IconSparkles />
					<span>What&#39;s New</span>
				</div>
			}
		>
			<ChangeLog />
		</Modal>
	)
}
